import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c5e7214"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column flex-lg-row mb-5" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "col-12 col-lg-5 col-form-label fw-bold required"
}, "Archivo", -1))
const _hoisted_3 = { class: "col-12 col-lg-7" }
const _hoisted_4 = ["value"]
const _hoisted_5 = ["accept"]
const _hoisted_6 = ["title"]
const _hoisted_7 = {
  key: 0,
  class: "spinner-border text-secondary mx-auto"
}
const _hoisted_8 = {
  key: 0,
  class: "mt-1 mb-0 w-100"
}
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  key: 2,
  class: "invalid-feedback text-danger fw-bold mb-0"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "d-flex flex-column flex-lg-row mb-5" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "col-12 col-lg-5 col-form-label fw-bold required"
}, "Nombre", -1))
const _hoisted_14 = { class: "col-12 col-lg-7" }
const _hoisted_15 = {
  key: 0,
  class: "mt-1 mb-0"
}
const _hoisted_16 = { class: "d-flex flex-column flex-lg-row mb-5" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "col-12 col-lg-5 col-form-label fw-bold"
}, "Observaciones", -1))
const _hoisted_18 = { class: "col-12 col-lg-7" }
const _hoisted_19 = { class: "d-flex flex-column flex-lg-row mb-5" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "col-12 col-lg-5 col-form-label fw-bold"
}, "Archivo", -1))
const _hoisted_21 = { class: "col-12 col-lg-7" }
const _hoisted_22 = {
  for: "",
  class: "form-control form-control-solid"
}
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "d-flex flex-column flex-lg-row mb-5" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "col-12 col-lg-5 col-form-label fw-bold"
}, "Nombre", -1))
const _hoisted_26 = { class: "col-12 col-lg-7" }
const _hoisted_27 = {
  for: "",
  class: "form-control form-control-solid"
}
const _hoisted_28 = { class: "d-flex flex-column flex-lg-row mb-5" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "col-12 col-lg-5 col-form-label fw-bold"
}, "Comentarios", -1))
const _hoisted_30 = { class: "col-12 col-lg-7" }
const _hoisted_31 = {
  for: "",
  class: "form-control form-control-solid"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.isReadOnly)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", {
                class: _normalizeClass(["input-group has-validation mb-2", { 'no-click': _ctx.settings.attributes.disabled }])
              }, [
                _createElementVNode("input", _mergeProps(_ctx.attributes, {
                  class: ["form-control form-control-solid", { 'is-invalid': _ctx.validationState.file?.$error || _ctx.error }],
                  value: _ctx.fileName ?? '',
                  onKeydown: _cache[0] || (_cache[0] = (event) => event.preventDefault()),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$refs[_ctx.ref].click()))
                }), null, 16, _hoisted_4),
                _createElementVNode("input", {
                  ref: _ctx.ref,
                  type: "file",
                  class: "d-none",
                  accept: _ctx.acceptAttr,
                  onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.getFile && _ctx.getFile(...args)))
                }, null, 40, _hoisted_5),
                _createElementVNode("span", {
                  class: "input-group-text cursor-pointer show-dialog-button",
                  "data-bs-toggle": "tooltip",
                  "data-bs-placement": "right",
                  title: _ctx.hasFile ? 'Remover' : 'Cargar',
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.hasFile ? _ctx.clear() : _ctx.$refs[_ctx.ref].click()))
                }, [
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7))
                    : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                        key: 1,
                        icon: _ctx.icon,
                        size: "lg",
                        class: "mx-auto"
                      }, null, 8, ["icon"]))
                ], 8, _hoisted_6),
                (_ctx.validationState.file?.$errors?.length)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validationState.file.$errors, (e) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: e.$uid,
                          class: "text-danger fw-bold mb-0"
                        }, _toDisplayString(e.$message), 1))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.serverErrors.length)
                  ? (_openBlock(), _createElementBlock("ul", {
                      key: 1,
                      class: _normalizeClass(["mb-0", { 'mt-1': !_ctx.validationState.file?.$errors?.length }])
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.serverErrors, (serverError, index) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: `${_ctx.settings.attributes.name}-error-${index}`,
                          class: "text-danger fw-bold mb-0"
                        }, [
                          _createElementVNode("div", {
                            innerHTML: _ctx.$sanitize(serverError)
                          }, null, 8, _hoisted_9)
                        ]))
                      }), 128))
                    ], 2))
                  : _createCommentVNode("", true),
                (_ctx.error)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.error), 1))
                  : _createCommentVNode("", true)
              ], 2),
              (_ctx.canPreview)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("span", {
                      class: "link-primary link-offset-2 cursor-pointer ms-1",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.preview && _ctx.preview(...args)))
                    }, "Previsualizar")
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.name) = $event)),
                type: "text",
                class: _normalizeClass(["form-control form-control-solid", { 'is-invalid': _ctx.validationState.name?.$error }]),
                placeholder: "Ingrese el nombre del archivo"
              }, null, 2), [
                [
                  _vModelText,
                  _ctx.name,
                  void 0,
                  { trim: true }
                ]
              ]),
              (_ctx.validationState.name?.$errors?.length)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_15, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validationState.name.$errors, (e) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: e.$uid,
                        class: "text-danger fw-bold mb-0"
                      }, _toDisplayString(e.$message), 1))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.comments) = $event)),
                class: "form-control form-control-solid resize-none",
                rows: "3",
                placeholder: "Ingrese observaciones para el documento"
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.comments,
                  void 0,
                  { trim: true }
                ]
              ])
            ])
          ])
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.fileName ?? ""), 1),
              (_ctx.canPreview)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createElementVNode("span", {
                      class: "link-primary link-offset-2 cursor-pointer ms-1",
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.preview && _ctx.preview(...args)))
                    }, "Previsualizar")
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.value?.name ?? ""), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.value?.comments ?? ""), 1)
            ])
          ])
        ], 64))
  ]))
}